import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { getTheme } from '../../global/utils';
import { Link } from 'react-router-dom';
import Loading from '../../components/loading/Loading';
import Noresults from '../../components/noresults/Noresults';
import Button from '../../components/buttons/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const TableListWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
  ${props =>
    props.loading ||
    (props.noData &&
      css`
        table {
          width: 100%;
          border-top: 1px solid ${getTheme('black', '_800')};
        }
        thead {
          display: none;
        }
      `)};
  table {
    table-layout: fixed;
    text-align: left;
    max-width: 100%;
    border-collapse: collapse;
  }
  th,
  td {
    text-align: left;
    border-left: 1px solid ${getTheme('black', '_800')};
    border-right: 1px solid ${getTheme('black', '_800')};
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: ${getTheme('padding', 'verticalM')} ${getTheme('padding', 'horizontalM')};
  }
  th {
    border-left: 1px solid ${getTheme('black', '_200')};
    border-right: 1px solid ${getTheme('black', '_200')};
    background-color: ${getTheme('black', '_300')};
    color: ${getTheme('black', '_750')};
    font-weight: 400;
  }

  td {
    border-bottom: 1px solid ${getTheme('black', '_800')};
    transition: background-color 0.2s;
  }
  .table-list__rowdata:hover {
    td {
      cursor: pointer;
      background-color: ${getTheme('black', '_950')};
    }
  }
  .table-link {
    display: block;
    margin: -${getTheme('padding', 'verticalM')} -${getTheme('padding', 'horizontalM')};
    padding: ${getTheme('padding', 'verticalM')} ${getTheme('padding', 'horizontalM')};
    color: inherit;
    text-decoration: none;
    &:hover {
      color: inherit;
    }
    &:focus {
      outline: 0;
    }
  }
  .table-list-number {
    font-weight: 700;
    border-right-width: 2px;
    text-align: center;
    font-size: ${getTheme('fontSize', 'caption')};
    padding-left: ${getTheme('padding', 'horizontalXS')};
    padding-right: ${getTheme('padding', 'horizontalXS')};
  }
  td.table-list-number {
    background-color: ${getTheme('bg', 'light3')};
  }
  .table-list-number .table-link {
    margin-left: -${getTheme('padding', 'horizontalXS')};
    margin-right: -${getTheme('padding', 'horizontalXS')};
    padding-left: ${getTheme('padding', 'horizontalXS')};
    padding-right: ${getTheme('padding', 'horizontalXS')};
  }

  .table-alarm-name {
/*    width: 20em;
    max-width: 50em;*/
    a {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .table-no-data td,
  .table-loading td {
    position: relative;
    height: 30rem;
  }

  td.center {
    text-align: center;
  }
  .tooltip-inner {
    white-space: pre-wrap;
  }
`;

class AlarmsTableList extends Component {
  constructor() {
    super();
    this.state = {
      isCtrlPressed: false,
    };
    this.checkKey = this.checkKey.bind(this);
    this.releaseKey = this.releaseKey.bind(this);
  }
  checkKey(event) {
    if (event.key === 'Meta' || event.key === 'Control') {
      this.setState({
        isCtrlPressed: true,
      });
    }
  }

  releaseKey() {
    this.setState({
      isCtrlPressed: false,
    });
  }

  componentDidMount() {
    window.addEventListener('keydown', this.checkKey);
    window.addEventListener('keyup', this.releaseKey);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.checkKey);
    window.removeEventListener('keyup', this.releaseKey);
  }

  render() {
    let alarmsData = this.props.data;
    let rows = alarmsData.map((item, key) => (
      <tr
        className="table-list__rowdata"
        key={key}
        onClick={e => this.props.handleClick(item, this.state.isCtrlPressed, key, e)}
      >
        <td className="table-list-number">
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
            }}
            target="_blank"
            className="table-link"
          >
            {key + 1}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link"
          >
            {item.date ? item.date + ' · ' + item.time : ''}
          </Link>
        </td>
        <td className="center">
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link"
          >
            {item.ut}
          </Link>
        </td>
        <td className="center">
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link center"
          >
            {item.sec}
          </Link>
        </td>
        <td className="center">
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link"
          >
            {item.groupid}
          </Link>
        </td>
        <td className="center">
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link"
          >
            {item.triggerid}
          </Link>
        </td>
        <td className="table-alarm-name">
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link"
          >
            {item.alarms}
          </Link>
        </td>
        <td className="center" title={item.crc}>
          <Link
            to={{
              pathname: '/snapshots/?id=' + key,
              state: {
                item: item,
              },
            }}
            target="_blank"
            className="table-link"
          >
            {item.crc}
          </Link>
        </td>
      </tr>
    ));

    return (
      <TableListWrapper loading={this.props.loading} noData={this.props.noData}>
        <table>
          <thead>
            <tr>
              <th className="table-list-number" />
              <th>Date · Time</th>
              <th>UT</th>
              <th>Counter</th>
              <th>Group</th>
              <th>Trigger</th>
              <th className="table-alarm-name">Alarms</th>
              <th>CRC</th>
            </tr>
          </thead>
          <tbody>
            {!this.props.loading && !this.props.noData && rows}
            {this.props.loading && (
              <tr className="table-loading">
                <td colSpan="8">
                  <Loading heading="Loading the alarms" text="It might take a while." />
                </td>
              </tr>
            )}
            {this.props.noData && (
              <tr className="table-no-data">
                <td colSpan="8">
                  <Noresults
                    heading="Sorry, no data matched your criteria."
                    text="You can try to change the filters to get results."
                    noresultsButton={
                      <Button
                        className="noresults__trigger"
                        secondary
                        size="xsmall"
                        onClick={this.props.noDataAction}
                        iconBefore={<FontAwesomeIcon icon={faFilter} />}
                      >
                        Filter
                      </Button>
                    }
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableListWrapper>
    );
  }
}

export default AlarmsTableList;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsTableList.js